import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  Fade,
  Link,
} from "@mui/material";
import Navbar from "../../components/navbar/NavBar";
import Footer from "../../components/navbar/Footer";

const BlogListPage = () => {
  const blogs = [
    {
      id: 1,
      title: "Why is Vastu Shastra Essential for Modern Homes?",
      excerpt:
        "Discover how ancient Vastu principles can transform your living space into a haven of positive energy and prosperity.",
      image:
        "https://res.cloudinary.com/duaz5kg1m/image/upload/v1739479212/What_is_Vastu_2x_gmahch.jpg",

      date: "February 10, 2025",
      readTime: "5 min read",
      navigate: "/blog/why-vastu-is-needed",
    },
    {
      id: 2,
      title: "Getting Started with VastuPlan: A Beginner's Guide",
      excerpt: "Learn how to get the best of our system",
      image:
        "https://res.cloudinary.com/duaz5kg1m/image/upload/v1739479265/vastushastra001_f1ivon.jpg",
      date: "February 8, 2025",
      readTime: "7 min read",
      navigate: "/blog/a-beginner-guide",
    },
  ];

  return (
    <Box sx={{ background: "#ffffff", minHeight: "100vh", color: "#333333" }}>
      <Navbar />

      <Container sx={{ pt: 15, pb: 8 }}>
        <Fade in timeout={1000}>
          <Box>
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                color: "#bb0000",
                fontWeight: 700,
                position: "relative",
                mb: 6,
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: "80px",
                  height: "4px",
                  background: "#bb0000",
                  borderRadius: "2px",
                },
              }}
            >
              Vastu Insights
            </Typography>

            <Grid container spacing={4}>
              {blogs.map((blog) => (
                <Grid item xs={12} md={4} key={blog.id}>
                  <Link href={`${blog.navigate}`} className="no-underline">
                    <Card
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-8px)",
                          boxShadow: "0 20px 40px rgba(187, 0, 0, 0.1)",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={blog.image}
                        alt={blog.title}
                        sx={{
                          width: "100%",
                          height: 200,
                          objectFit: "cover",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        }}
                      />
                      <Box sx={{ p: 3, flexGrow: 1 }}>
                        <Typography
                          variant="subtitle2"
                          sx={{ color: "#666666", mb: 1 }}
                        >
                          {blog.date} · {blog.readTime}
                        </Typography>
                        <Typography
                          variant="h5"
                          component="h2"
                          gutterBottom
                          sx={{ color: "#bb0000", fontWeight: 600 }}
                        >
                          {blog.title}
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#555555" }}>
                          {blog.excerpt}
                        </Typography>
                      </Box>
                    </Card>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Fade>
      </Container>
      <Footer />
    </Box>
  );
};

export default BlogListPage;
